// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"MoreButton_moreButton__20_Rc"};